import { Box, Stack, SwipeableDrawer, useMediaQuery } from '@mui/material';
import CreditDetails from './CreditDetails';
import RemainingTasks from './RemainingTasks';
import PlanDetails from './PlanDetails';
import { useSelector } from 'react-redux';

export default function CreditsAndPlansDetailsDrawer({ open, toggleDrawer, isMapitShipOnly }) {
    const { openCreditPopper } = useSelector(state => state.entities.tutorial)
    const isDownMd = useMediaQuery((theme) => theme.breakpoints.down('md'));

    return (
        <SwipeableDrawer
            anchor={"bottom"}
            open={open || (openCreditPopper && isDownMd)}
            onClose={toggleDrawer(false)}
            onOpen={toggleDrawer(true)}
        >
            <Box
                sx={{ width: 'auto' }}
                role="presentation"
                onClick={toggleDrawer(false)}
                onKeyDown={toggleDrawer(false)}
                p={2}
            >
                <Stack spacing={3}>
                    {!isMapitShipOnly && <RemainingTasks />}
                    <CreditDetails />
                    {!isMapitShipOnly && <PlanDetails />}
                </Stack>
            </Box>
        </SwipeableDrawer>
    );
}
